import React, { Component } from "react";
import "./style.scss";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import Heading from "../../elements/heading";
import { connect } from "react-redux";
import { gtag } from "../../utils";
import { setDynamicBreadcrumbList } from "../../redux/actions/actions";

class HeroStory extends Component {
  handClick(e, value) {
    gtag('event', 'Component_info', {
      'component_name': 'HeroStory',
      'page_title': this?.props?.page?.name
    });
    e.preventDefault();
    let obj = {
      href: "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(window.location.href),
      target: "_blank",
      specs: "toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350"
    };
    switch (value) {
      case "facebook":
        obj.href = "http://www.facebook.com/sharer.php?u=" + encodeURIComponent(window.location.href);
        break;
      case "linkedin":
        obj.href = "http://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(window.location.href);
        break;
      case "twitter":
        obj.href = "https://twitter.com/intent/tweet?text=&url=" + encodeURIComponent(window.location.href);
        break;
      default:
        break;
    }
    window.open(obj.href, obj.target, obj.specs);
  }
  socialShow() {
    let title = document.querySelector("title") ? document.querySelector("title").innerText : "";
    let text = document.querySelector('meta[name="description"]') ? document.querySelector('meta[name="description"]').getAttribute("content") : "";
    let url = window.location.href;
    if (navigator.share) {
      navigator
        .share({
          title: title,
          text: text,
          url: url
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    }
  }
  render() {
    if (!this.props.fields) return null;
    const { fields, rendering, setDynamicBreadcrumbList } = this.props;
    const { date, backgroundImage, barColor, backgroundColor, overlineText, headingType, headingBody, author, subjects } = fields;
    let divHeroStoryBackgroundStyle = {};
    let bottomBarStyle = {};
    let monthArr = ["Jan", "Feb", "Mar", "Apr", "May", "June ", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];

    /***
     * Hero story is shown on page not in model
     * fix the bread crumbs
     */
    if (this.props.pathname === window.location.pathname) {
      let breadCrumbNode = {
        breadcrumbName: this.props?.page?.displayName
      };
      setDynamicBreadcrumbList([breadCrumbNode]);
    }

    if (date != null && date.value != null) {
      let dateArr = date.value.split("T")[0].split("-");
      let localDateStr = dateArr[0] !== "0001" ? monthArr[Number(dateArr[1]) - 1] + " " + dateArr[0] : "";
      fields.localDate = { value: localDateStr };
    }
    if (backgroundImage && backgroundImage.value) {
      divHeroStoryBackgroundStyle = {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5) ), url(" + backgroundImage.value.src + ")"
      };
    }
    let authorBorderStyle = {
      borderColor: barColor && barColor.fields && barColor.fields.phrase.value
    };
    let backgroundStyle = {
      background: backgroundColor ? backgroundColor.fields.phrase.value : "transparent"
    };
    let socialLinks = classNames("social-links");
    return (
      <div className={"hero-story grid"} datasourceid={rendering.dataSource} style={backgroundStyle}>
        <div style={divHeroStoryBackgroundStyle} className={"full-width background"}>
          <div className={"grid-story"}>
            {overlineText != null && <RichText tag="span" className="overline" field={overlineText} />}

            <Heading
              {...{
                type: headingType
                  ? headingType
                  : {
                      fields: { key: { value: "h2" }, phrase: { value: "h2" } }
                    },
                html: headingBody
              }}
              className={"title"}
            />
            {((date != null && date.value != null) || (author != null && author.value)) && (
              <div className={"story-stamps"} style={authorBorderStyle}>
                {date != null && date.value != null && <span>{fields.localDate.value}</span>}
                {author != null && author.value && <span>by {author.value}</span>}
              </div>
            )}
          </div>

          <div className={"bottom-bar grid-story"} style={bottomBarStyle}>
            <div className={"border"} />
            {subjects.length !== 0 && (
              <div className="subjects">
                {subjects.map((subject, index) => {
                  return <RichText tag="span" key={index} field={subject.fields.key} />;
                })}
              </div>
            )}
            <div className={socialLinks}>
              <span className={"social"} onClick={this.socialShow.bind(this)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
                </svg>
              </span>
              <span className={"social"} onClick={e => this.handClick(e, "facebook")}>
                <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" className="svg-inline--fa fa-facebook-f fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                  <path fill="currentColor" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
                </svg>
              </span>
              <span className={"social"} onClick={e => this.handClick(e, "twitter")}>
                <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter" className="svg-inline--fa fa-twitter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    fill="currentColor"
                    d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                  />
                </svg>
              </span>
              <span className={"social"} onClick={e => this.handClick(e, "linkedin")}>
                <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin-in" className="svg-inline--fa fa-linkedin-in fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    fill="currentColor"
                    d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                  />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setDynamicBreadcrumbList: breadcrumbList => dispatch(setDynamicBreadcrumbList(breadcrumbList)),
  dispatch
});

export default connect(null, mapDispatchToProps)(HeroStory);
